// @ts-nocheck
import { PropsWithChildren, useState } from 'react';

import '@material/web/select/filled-select.js';
import '@material/web/select/outlined-select.js';
import '@material/web/select/select-option.js';

export interface SelectOption {
  id?: number;
  value: string;
  content: string;
  'data-cy'?: string;
}

interface SelectOptionProps {
  isSelected: boolean;
  option: SelectOption;
  onSelect: (option: SelectOption) => void;
}

const SelectOption = ({ isSelected, option, onSelect }: SelectOptionProps) => {
  const props = {};
  if (isSelected) {
    props.selected = isSelected;
  }
  return (
    <md-select-option
      {...props}
      value={option.value}
      onClick={() => onSelect(option)}
      data-cy={option['data-cy']}
    >
      {option.content}
    </md-select-option>
  );
};

export interface SelectProps extends PropsWithChildren {
  variant?: 'filled' | 'outlined';
  disabled?: boolean;
  required?: boolean;
  options: SelectOption[];
  defaultValue?: string | null;
  label?: string;
  width?: string;
  onChange?: (option: SelectOption) => void;
  'data-cy'?: string;
}

export const Select = ({
  variant = 'filled',
  disabled = false,
  required,
  options,
  defaultValue = null,
  label,
  width,
  onChange,
  'data-cy': dataCy,
}: SelectProps) => {
  const [selectedOption, setSelectedOption] = useState(() => {
    if (defaultValue !== null) {
      return defaultValue;
    }
  });

  const selectProps = {};
  if (required) {
    selectedOption.required = required;
  }
  if (disabled) {
    selectProps.disabled = disabled;
  }
  if (label) {
    selectProps.label = label;
  }
  if (width) {
    selectProps.width = width;
  }

  const selectChangeHandler = (option: SelectOption) => {
    setSelectedOption(option.value);
    onChange(option);
  };

  if (variant === 'filled') {
    return (
      <md-filled-select
        {...selectProps}
        style={{ width: selectProps.width }}
        data-cy={dataCy}
      >
        {options.map((option, idx) => (
          <SelectOption
            key={idx}
            isSelected={selectedOption === option.value}
            option={option}
            onSelect={selectChangeHandler}
          />
        ))}
      </md-filled-select>
    );
  } else {
    return (
      <md-outlined-select
        {...selectProps}
        style={{ width: selectProps.width }}
        data-cy={dataCy}
      >
        {options.map((option, idx) => (
          <SelectOption
            key={idx}
            option={option}
            isSelected={selectedOption === option.value}
            onSelect={selectChangeHandler}
          />
        ))}
      </md-outlined-select>
    );
  }
};
